export class TimeManagerProject {
  Id: number;
  RecordId: number;
  ProjectId: number;
  ManagerId: number;
  IsSupervisor: boolean;
  CreatedBy: number;
  CreatedDate: string;
  ModifiedBy: number;
  ModifiedDate: string;
  IsArchived: boolean;
  IsDeleted: boolean;

  constructor(obj?: Partial<TimeManagerProject>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }
}
